import { render, staticRenderFns } from "./LocaleVerifyEditDialog.vue?vue&type=template&id=41c8a499&scoped=true"
import script from "./LocaleVerifyEditDialog.vue?vue&type=script&lang=js"
export * from "./LocaleVerifyEditDialog.vue?vue&type=script&lang=js"
import style0 from "./LocaleVerifyEditDialog.vue?vue&type=style&index=0&id=41c8a499&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c8a499",
  null
  
)

export default component.exports